<template>
  <div>
    <div class="relative bg-white border-b border-gray-200 shadow rounded-lg overflow-hidden" :class="classList">
      <div
          class="absolute inset-0 flex flex-col justify-center items-center bg-special-trans-white-90 border-2 border-dashed text-primary-500 p-5"
          v-if="dragOverActive && !this.isImmutable">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 mb-4" fill="none" viewBox="0 0 24 24"
             stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M15 13l-3 3m0 0l-3-3m3 3V8m0 13a9 9 0 110-18 9 9 0 010 18z"/>
        </svg>
        <div class="text-lg text-center">{{ $t('Drop files here to upload them to this area') }}
        </div>
      </div>
      <div class="px-4 py-5 sm:px-6 items-center justify-between flex flex-row">
        <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
          <div class="ml-4 mt-4">
            <h3 class="text-xl leading-6 font-bold text-primary-500 mb-0">
              {{ container.name }}
            </h3>
          </div>
        </div>
      </div>
      <FileContainerContent
          class="flow-root my-4"
          :files="container.files"
          :has-special-date-layout="hasSpecialDateLayout"
          :mutation-disabled="isImmutable">
      </FileContainerContent>
    </div>
    <AlertBox type="danger" class="mt-6" v-if="uploadErrors.length > 0">
      <p class="font-semibold">{{ $t('The file could not be uploaded.') }}</p>
      <ul class="list-disc list-inside mt-1">
        <li v-for="(message, index) in uploadErrors" :key="index">{{ message }}</li>
      </ul>
    </AlertBox>
    <div class="py-6 border-t mt-10" v-if="!this.isImmutable || this.container.files.length > 0">
      <div class="flex justify-between items-center flex-wrap sm:flex-nowrap">
        <div>
          <jet-secondary-button type="button" @click.prevent="downloadArchive"
                                v-if="this.container.files.length > 0"
                                :class="{'opacity-25':this.container.files.length < 1}"
                                :disabled="this.container.files.length < 1">
            {{ $t('Download ZIP') }}
          </jet-secondary-button>
        </div>
        <div v-if="!this.isImmutable">
          <input type="file" class="hidden"
                 ref="fileInput" @change="uploadFile" multiple/>
          <jet-button type="button" @click.prevent="chooseFile"
                      :class="[{ 'opacity-25': form.processing }]"
                      :disabled="form.processing">
            <template v-if="form.processing">
              <svg xmlns="http://www.w3.org/2000/svg" class="animate-spin h-4 w-4" fill="none"
                   viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
              </svg>
            </template>
            <template v-else>
              {{ $t('Upload file') }}
            </template>
          </jet-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JetButton from "@/Jetstream/Button";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import FileContainerFile from "@/Components/FileContainerFile";
import FileContainerContent from "./FileContainerContent";
import JetActionMessage from "@/Jetstream/ActionMessage";
import AlertBox from "@/Components/AlertBox.vue";

export default {
  name: "FileContainer",
  components: {
    FileContainerContent,
    JetButton,
    JetSecondaryButton,
    FileContainerFile,
    JetActionMessage,
    AlertBox,
  },
  props: {
    container: Object,
    mutationDisabled: Boolean,
  },
  computed: {
    classList() {
      return (this.isImmutable ? 'opacity-85' : '');
    },
    uploadErrors() {
      return Object.values(this.form.errors);
    },
    isImmutable() {
      return (!this.container.is_active) || this.mutationDisabled;
    },
    hasSpecialDateLayout() {
      return this.container.is_invoices_container || this.container.is_reports_container;
    }
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'POST',
        files: null,
      }),
      dragOverActive: false,
    };
  },
  methods: {
    downloadArchive() {
      window.location.href = route('container-download.show', {container: this.container.hash});
    },
    chooseFile() {
      this.$refs.fileInput.click();
    },
    uploadFile() {
      if (this.$refs.fileInput && !this.isImmutable) {
        this.form.files = this.$refs.fileInput.files;

        this.form.post(route('files.store', {container: this.container.hash}), {
          preserveScroll: true,
          preserveState: false,
          onSuccess: () => (this.clearFileInput()),
          onError: () => (this.clearFileInput()),
        });
      }
    },
    filesDropped(event) {
      if (event.dataTransfer.files && !this.isImmutable) {
        this.form.files = event.dataTransfer.files;

        this.form.post(route('files.store', {container: this.container.hash}), {
          preserveScroll: true,
          preserveState: false,
          onSuccess: () => (this.clearFileInput()),
          onError: () => (this.clearFileInput()),
        });
      }
    },
    clearFileInput() {
      if (this.$refs.fileInput?.value) {
        this.$refs.fileInput.value = null;
      }
    },
  },
}
</script>

<style scoped>

</style>
